/*  MUI  */
import { Box } from '@mui/material';

/*  Shared  */
import { TrialBanner } from 'application/Shared/Components/TrialBanner';
import { Sidebar } from 'application/Shared/Views/Components/Sidebar/Sidebar';

/* Hooks */
import { useIsOnTrialFromPartnerTenantInfo } from 'hooks/dataAccess/Session/isOnTrial';
import { useSession } from 'hooks/redux/Selectors/session';

/*  React  */
import React from 'react';

import { TenantLoader } from './TenantLoader';

export const PartnerView = ({
    onlyShowChildrenElements,
    children,
    className,
    page
}: {
    onlyShowChildrenElements?: boolean;
    children: React.ReactNode;
    className?: string;
    page?: string;
}): React.ReactNode => {
    const session = useSession();

    const displayTrialBanner = useIsOnTrialFromPartnerTenantInfo();

    if (!session) {
        return null;
    }

    if (onlyShowChildrenElements) {
        return children;
    }

    return (
        <TenantLoader>
            <Box
                data-testid="sharedComponentsPartnerView"
                display="flex"
                width="100%"
            >
                {displayTrialBanner && <TrialBanner />}
                <Box
                    className={displayTrialBanner ? 'trialBannerMargin' : ''}
                    display="flex"
                    width="100%"
                >
                    <Sidebar partnerView page={page} />
                    <Box id="mainViewContainer" className={className}>
                        {children}
                    </Box>
                </Box>
            </Box>
        </TenantLoader>
    );
};
